import React, { useState, useEffect } from "react";
import "./CookiesInfo.css";
import CookieConsent from "../../utils/CookieConsent";

function CookiesInfo() {
    const [isVisible, setIsVisible] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);
    const [preferences, setPreferences] = useState({
        preferences: false,
        statistics: false,
        marketing: false
    });

    // Load logic: check localStorage on mount
    useEffect(() => {
        const stored = localStorage.getItem(CookieConsent.STORAGE_KEY);
        if (!stored) {
            setIsVisible(true);
        } else {
            try {
                // Optional: Load saved preferences into state if needed for re-opening
                const parsed = JSON.parse(stored);
                setPreferences(parsed);
            } catch (e) {
                console.error("Failed to parse cookie preferences", e);
            }
        }
    }, []);

    // Blocks scrolling/interacting with the page behind the modal while it's shown
    useEffect(() => {
        document.body.style.overflow = isVisible ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isVisible]);

    const saveState = (values) => {
        CookieConsent.save(values);
        setIsVisible(false);
    };

    const handleAcceptAll = () => {
        const allAccepted = {
            preferences: true,
            statistics: true,
            marketing: true
        };
        setPreferences(allAccepted); // Update UI state
        saveState(allAccepted);
    };

    const handleRejectAll = () => {
        const allRejected = {
            preferences: false,
            statistics: false,
            marketing: false
        };
        setPreferences(allRejected); // Update UI state
        saveState(allRejected);
    };

    const handleSavePreferences = () => {
        saveState(preferences);
    };

    const handleToggle = (key) => {
        setPreferences(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    if (!isVisible) return null;

    return (
        <div id="CookieConsent" className={isVisible ? "" : "hidden"}>
            <div className="cookie-overlay" />
            <div className="cookie-modal">
                <button className="close-btn" onClick={() => setIsVisible(false)}>×</button>

                <h5>Zarządzaj zgodą</h5>
                <p>
                    Aby zapewnić jak najlepsze wrażenia, korzystamy z technologii, takich jak pliki cookie, do przechowywania i/lub uzyskiwania dostępu do informacji o urządzeniu. Zgoda na te technologie pozwoli nam przetwarzać dane, takie jak zachowanie podczas przeglądania lub unikalne identyfikatory na tej stronie. Brak wyrażenia zgody lub wycofanie zgody może niekorzystnie wpłynąć na niektóre cechy i funkcje.
                </p>

                {/* Preferences block */}
                <div id="cookie-details" className={`cookie-section ${showPreferences ? "" : "hidden"}`}>
                    <div className="cookie-row">
                        <span>Funkcjonalne</span>
                        <span className="always-on">Zawsze aktywne</span>
                    </div>

                    <div className="cookie-row toggle">
                        <span>Preferencje</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                id="cc-preferences"
                                checked={preferences.preferences}
                                onChange={() => handleToggle("preferences")}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                    <div className="cookie-row toggle">
                        <span>Statystyka</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                id="cc-statistics"
                                checked={preferences.statistics}
                                onChange={() => handleToggle("statistics")}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                    <div className="cookie-row toggle">
                        <span>Marketing</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                id="cc-marketing"
                                checked={preferences.marketing}
                                onChange={() => handleToggle("marketing")}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>
                </div>

                <div className="cookie-buttons">
                    {showPreferences ? (
                        <button className="accept" onClick={handleSavePreferences}>Zapisz wybrane</button>
                    ) : (
                        <button className="accept" onClick={handleAcceptAll}>Akceptuj</button>
                    )}
                    
                    <button className="reject" onClick={handleRejectAll}>Odrzuć</button>
                    
                    <button className="prefs" onClick={() => setShowPreferences(!showPreferences)}>
                        {showPreferences ? "Ukryj preferencje" : "Zobacz preferencje"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookiesInfo;